import React, {PureComponent} from "react";
import {Box, Card, Typography} from "@mui/material";

import {BORDER_RADIUS_MEDIUM, PD_LG, PD_SM, PD_XLG, SZ_MD, SZ_SMD} from "../../shared/dimens";
import {COLOR_PRIMARY, COLOR_SECONDARY} from "../App";
import {lightGray} from "../../shared/colors";
import {Applet} from "../Applets";
import {BaseApp} from "../../shared/BaseApp";

export type AppletCardProps = {
  style?: any,
  applet: Applet,
  onClick: () => void,
}

export class AppletCard extends PureComponent<AppletCardProps> {

  private readonly theme = BaseApp.CONTEXT.getAppConfig().theme;

  render() {
    const applet = this.props.applet;
    return <Card
      style={{
        borderRadius: 12,
        padding: PD_LG,
        background: this.theme.palette.background.paper,
        cursor: "pointer",
        ...this.props.style
      }}
      onClick={() => this.props.onClick()}>
      <Box style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        padding: PD_SM,
        gap: PD_XLG
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: PD_LG,
        }}>
          <applet.iconType style={{width: SZ_MD, height: SZ_MD, color: this.theme.palette.secondary.main}}/>
        </div>
        <Typography><b>{applet.name}</b></Typography>
      </Box>
    </Card>
  }
}